/**
 * A compact identity for the deck currently being shown.
 *
 * The web invite page rebuilds arrays often as catalogue data arrives. Reacting
 * to those array references reset the iMessage deck while somebody was
 * re-entering it, even when the actual restaurant order had not changed.
 *
 * @param {{id: number|string}[]} restaurants
 * @returns {string}
 */
export function deckSignature(restaurants) {
  return restaurants.map((restaurant) => String(restaurant.id)).join('|');
}

/**
 * The first card this member has not already answered.
 *
 * Used when a message bubble is opened again: the session remembers votes, so
 * the deck should resume instead of trapping the person on cards they already
 * swiped.
 *
 * @param {{id: number|string}[]} restaurants
 * @param {Record<string, 'left'|'right'> | null | undefined} votes
 * @returns {number}
 */
export function firstUnvotedDeckIndex(restaurants, votes) {
  const answered = votes ?? {};
  const index = restaurants.findIndex((restaurant) => answered[String(restaurant.id)] == null);
  return index >= 0 ? index : restaurants.length;
}
